export default product => ({
  parent_id: '0',
  level: 0,
  url: 'jardin-piscine-823',
  id: '823',
  name: 'Jardin piscine',
  product_count: 44,
  children: [
    {
      url: 'mobilier-de-jardin-et-jeux-1166',
      id: '1166',
      parent_id: '823',
      level: 1,
      name: 'Mobilier de jardin et jeux',
      children: [
        {
          url: 'hamac-et-balancelle-2964',
          id: '2964',
          name: 'Hamac et balancelle (755)',
        },
      ],
    },
  ],
  ...product,
});
